import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@material-ui/core'

import { Routes } from 'app/services/routeService/routeService'

const LinkToSignup = ({ text = 'Go back to Sign up methods' }) => {
  return (
    <div className="py-10 text-center">
      <Link
        className="p-0 text-red-400 text-14 font-400 normal-case hover:bg-transparent text-nowrap"
        href={Routes.signIn()}
      >
        {text}
      </Link>
    </div>
  )
}

LinkToSignup.propTypes = {
  text: PropTypes.string,
}

export default LinkToSignup
